import ValidatedRadio from './ValidatedRadio';

export { Props } from './ValidatedRadio';
export default ValidatedRadio;
